import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import Availability from "Components/Availability";
	

const SubstitutorAvailability = () => {
	
	return (
		<Fragment>
			
				<div>
					<PageHeading />

					<Row>
						<Col md="12" lg="12">
							<Availability>
								<Availability.Modals />
								<Availability.Container>
									<Availability.Table />
								</Availability.Container>
								<Availability.Footer/>
							</Availability>
						</Col>
					</Row>
				</div>
			
		</Fragment>
	);
};

export default SubstitutorAvailability;
